"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeControllerListCompetitionsV1SortOrderEnum = exports.HomeControllerListCompetitionsV1FilterEnum = exports.HomeApi = exports.HomeApiFactory = exports.HomeApiFp = exports.HomeApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * HomeApi - axios parameter creator
 * @export
 */
var HomeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Explore approved submissions with optional filters
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Page size
         * @param {ExploreSort} [sort] Sort order
         * @param {Array<string>} [subcategoryIds] Filter by subcategory ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerExploreV1: function (page_1, limit_1, sort_1, subcategoryIds_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, sort_1, subcategoryIds_1], args_1, true), void 0, function (page, limit, sort, subcategoryIds, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/home/explore";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (subcategoryIds) {
                                localVarQueryParameter['subcategoryIds'] = subcategoryIds;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get subcategory filters (interested first, then others; only active)
         * @param {boolean} [isLive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetCompetitionFiltersV1: function (isLive_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([isLive_1], args_1, true), void 0, function (isLive, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/home/competitions/filters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (isLive !== undefined) {
                                localVarQueryParameter['is_live'] = isLive;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get explore subcategory filters (only those with at least one submission)
         * @param {ExploreSort} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetExploreFiltersV1: function (sort_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sort_1], args_1, true), void 0, function (sort, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/home/explore/filters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get latest videos
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetLatestV1: function (limit_1, page_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, page_1], args_1, true), void 0, function (limit, page, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/home/videos/latest";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get trending videos
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetTrendingV1: function (limit_1, page_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, page_1], args_1, true), void 0, function (limit, page, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/home/videos/trending";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competitions for home feed
         * @param {number} [page]
         * @param {number} [limit]
         * @param {HomeControllerListCompetitionsV1FilterEnum} [filter] Time-based filter(s): live, upcoming, past (comma-separated or repeated). Multiple values are ordered: past → live → upcoming
         * @param {HomeControllerListCompetitionsV1SortOrderEnum} [sortOrder] Sort order for live competitions: newest → oldest (default) or oldest → newest
         * @param {boolean} [isFree]
         * @param {boolean} [isPaid]
         * @param {Array<string>} [subcategoryIds] Multiple subcategory ids
         * @param {string} [search] Search competition title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerListCompetitionsV1: function (page_1, limit_1, filter_1, sortOrder_1, isFree_1, isPaid_1, subcategoryIds_1, search_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, filter_1, sortOrder_1, isFree_1, isPaid_1, subcategoryIds_1, search_1], args_1, true), void 0, function (page, limit, filter, sortOrder, isFree, isPaid, subcategoryIds, search, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/home/competitions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (sortOrder !== undefined) {
                                localVarQueryParameter['sort_order'] = sortOrder;
                            }
                            if (isFree !== undefined) {
                                localVarQueryParameter['is_free'] = isFree;
                            }
                            if (isPaid !== undefined) {
                                localVarQueryParameter['is_paid'] = isPaid;
                            }
                            if (subcategoryIds) {
                                localVarQueryParameter['subcategoryIds'] = subcategoryIds;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.HomeApiAxiosParamCreator = HomeApiAxiosParamCreator;
/**
 * HomeApi - functional programming interface
 * @export
 */
var HomeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HomeApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Explore approved submissions with optional filters
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Page size
         * @param {ExploreSort} [sort] Sort order
         * @param {Array<string>} [subcategoryIds] Filter by subcategory ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerExploreV1: function (page, limit, sort, subcategoryIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.homeControllerExploreV1(page, limit, sort, subcategoryIds, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HomeApi.homeControllerExploreV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get subcategory filters (interested first, then others; only active)
         * @param {boolean} [isLive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetCompetitionFiltersV1: function (isLive, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.homeControllerGetCompetitionFiltersV1(isLive, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HomeApi.homeControllerGetCompetitionFiltersV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get explore subcategory filters (only those with at least one submission)
         * @param {ExploreSort} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetExploreFiltersV1: function (sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.homeControllerGetExploreFiltersV1(sort, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HomeApi.homeControllerGetExploreFiltersV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get latest videos
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetLatestV1: function (limit, page, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.homeControllerGetLatestV1(limit, page, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HomeApi.homeControllerGetLatestV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get trending videos
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetTrendingV1: function (limit, page, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.homeControllerGetTrendingV1(limit, page, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HomeApi.homeControllerGetTrendingV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List competitions for home feed
         * @param {number} [page]
         * @param {number} [limit]
         * @param {HomeControllerListCompetitionsV1FilterEnum} [filter] Time-based filter(s): live, upcoming, past (comma-separated or repeated). Multiple values are ordered: past → live → upcoming
         * @param {HomeControllerListCompetitionsV1SortOrderEnum} [sortOrder] Sort order for live competitions: newest → oldest (default) or oldest → newest
         * @param {boolean} [isFree]
         * @param {boolean} [isPaid]
         * @param {Array<string>} [subcategoryIds] Multiple subcategory ids
         * @param {string} [search] Search competition title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerListCompetitionsV1: function (page, limit, filter, sortOrder, isFree, isPaid, subcategoryIds, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.homeControllerListCompetitionsV1(page, limit, filter, sortOrder, isFree, isPaid, subcategoryIds, search, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HomeApi.homeControllerListCompetitionsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.HomeApiFp = HomeApiFp;
/**
 * HomeApi - factory interface
 * @export
 */
var HomeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HomeApiFp)(configuration);
    return {
        /**
         *
         * @summary Explore approved submissions with optional filters
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Page size
         * @param {ExploreSort} [sort] Sort order
         * @param {Array<string>} [subcategoryIds] Filter by subcategory ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerExploreV1: function (page, limit, sort, subcategoryIds, options) {
            return localVarFp.homeControllerExploreV1(page, limit, sort, subcategoryIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get subcategory filters (interested first, then others; only active)
         * @param {boolean} [isLive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetCompetitionFiltersV1: function (isLive, options) {
            return localVarFp.homeControllerGetCompetitionFiltersV1(isLive, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get explore subcategory filters (only those with at least one submission)
         * @param {ExploreSort} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetExploreFiltersV1: function (sort, options) {
            return localVarFp.homeControllerGetExploreFiltersV1(sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get latest videos
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetLatestV1: function (limit, page, options) {
            return localVarFp.homeControllerGetLatestV1(limit, page, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get trending videos
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerGetTrendingV1: function (limit, page, options) {
            return localVarFp.homeControllerGetTrendingV1(limit, page, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List competitions for home feed
         * @param {number} [page]
         * @param {number} [limit]
         * @param {HomeControllerListCompetitionsV1FilterEnum} [filter] Time-based filter(s): live, upcoming, past (comma-separated or repeated). Multiple values are ordered: past → live → upcoming
         * @param {HomeControllerListCompetitionsV1SortOrderEnum} [sortOrder] Sort order for live competitions: newest → oldest (default) or oldest → newest
         * @param {boolean} [isFree]
         * @param {boolean} [isPaid]
         * @param {Array<string>} [subcategoryIds] Multiple subcategory ids
         * @param {string} [search] Search competition title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeControllerListCompetitionsV1: function (page, limit, filter, sortOrder, isFree, isPaid, subcategoryIds, search, options) {
            return localVarFp.homeControllerListCompetitionsV1(page, limit, filter, sortOrder, isFree, isPaid, subcategoryIds, search, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HomeApiFactory = HomeApiFactory;
/**
 * HomeApi - object-oriented interface
 * @export
 * @class HomeApi
 * @extends {BaseAPI}
 */
var HomeApi = /** @class */ (function (_super) {
    __extends(HomeApi, _super);
    function HomeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Explore approved submissions with optional filters
     * @param {number} [page] Page number (1-based)
     * @param {number} [limit] Page size
     * @param {ExploreSort} [sort] Sort order
     * @param {Array<string>} [subcategoryIds] Filter by subcategory ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    HomeApi.prototype.homeControllerExploreV1 = function (page, limit, sort, subcategoryIds, options) {
        var _this = this;
        return (0, exports.HomeApiFp)(this.configuration).homeControllerExploreV1(page, limit, sort, subcategoryIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get subcategory filters (interested first, then others; only active)
     * @param {boolean} [isLive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    HomeApi.prototype.homeControllerGetCompetitionFiltersV1 = function (isLive, options) {
        var _this = this;
        return (0, exports.HomeApiFp)(this.configuration).homeControllerGetCompetitionFiltersV1(isLive, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get explore subcategory filters (only those with at least one submission)
     * @param {ExploreSort} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    HomeApi.prototype.homeControllerGetExploreFiltersV1 = function (sort, options) {
        var _this = this;
        return (0, exports.HomeApiFp)(this.configuration).homeControllerGetExploreFiltersV1(sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get latest videos
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    HomeApi.prototype.homeControllerGetLatestV1 = function (limit, page, options) {
        var _this = this;
        return (0, exports.HomeApiFp)(this.configuration).homeControllerGetLatestV1(limit, page, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get trending videos
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    HomeApi.prototype.homeControllerGetTrendingV1 = function (limit, page, options) {
        var _this = this;
        return (0, exports.HomeApiFp)(this.configuration).homeControllerGetTrendingV1(limit, page, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List competitions for home feed
     * @param {number} [page]
     * @param {number} [limit]
     * @param {HomeControllerListCompetitionsV1FilterEnum} [filter] Time-based filter(s): live, upcoming, past (comma-separated or repeated). Multiple values are ordered: past → live → upcoming
     * @param {HomeControllerListCompetitionsV1SortOrderEnum} [sortOrder] Sort order for live competitions: newest → oldest (default) or oldest → newest
     * @param {boolean} [isFree]
     * @param {boolean} [isPaid]
     * @param {Array<string>} [subcategoryIds] Multiple subcategory ids
     * @param {string} [search] Search competition title
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    HomeApi.prototype.homeControllerListCompetitionsV1 = function (page, limit, filter, sortOrder, isFree, isPaid, subcategoryIds, search, options) {
        var _this = this;
        return (0, exports.HomeApiFp)(this.configuration).homeControllerListCompetitionsV1(page, limit, filter, sortOrder, isFree, isPaid, subcategoryIds, search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HomeApi;
}(base_1.BaseAPI));
exports.HomeApi = HomeApi;
/**
 * @export
 */
exports.HomeControllerListCompetitionsV1FilterEnum = {
    Live: 'live',
    Upcoming: 'upcoming',
    Past: 'past'
};
/**
 * @export
 */
exports.HomeControllerListCompetitionsV1SortOrderEnum = {
    Newest: 'newest',
    Oldest: 'oldest'
};
